export default "__VITE_ASSET__C$IdJcyy__"